<template>
  <div class="maskBox" @click="close">
    <div class="guide" @click.stop :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/guideBoxBg.webp')+')'}">
      <div class="title">{{$t('lang.cashWheel.youWithdraw')}}</div>
      <img class="close" src="../../assets/images/cashWheel/close.png" alt="" @click="close">
      <div class="minimum">{{$t('lang.cashWheel.minimum')}} <span class="value">₹500</span></div>
      <div class="maximum">{{$t('lang.cashWheel.maximum')}}<span class="value">₹5000</span></div>
      <div class="deepBox" :style="{'backgroundImage':'url('+require('../../assets/images/cashWheel/guideDeepBg.png')+')'}">
        <div class="deepBoxs">
          <div class="deepBg">
            <div class="deep" :style="{'height': deep+ '%'}"></div>
            <div class="nodeBox">
              <div  class="nodeIcon1">
                <div class="border1">
                  <div class="border2">
                    <div class="border3"></div>
                  </div>
                </div>
              </div>
              <div class="nodeIcon2">
                <div class="border1">
                  <div class="border2">
                    <div class="border3"></div>
                  </div>
                </div>
              </div>
              <div class="nodeIcon3">
                <div class="border1">
                  <div class="border2">
                    <div class="border3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="nodeTextBox">
          <div class="textItem">{{$t('lang.cashWheel.shareRegister')}} <img v-if="deep >= 0" class="finishIcon" src="../../assets/images/cashWheel/finishIcon.png"/> </div>
          <div class="textItem">{{$t('lang.cashWheel.inviteFriends')}} <img v-if="deep > 50" class="finishIcon" src="../../assets/images/cashWheel/finishIcon.png"/></div>
          <div class="textItem">{{$t('lang.cashWheel.withdrawalSuccessful')}} <img v-if="deep >= 100" class="finishIcon" src="../../assets/images/cashWheel/finishIcon.png"/></div>
        </div>
      </div>
      <div class="goInviteBtn" @click.stop="goInvite">{{$t('lang.cashWheel.GoInvite')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-guide',
  data () {
    return {
      deep: 0
    }
  },
  mounted () {
    setTimeout(() => {
      this.deep = 50
    }, 300)
  },
  methods: {
    close () {
      this.$emit('closeModalGuide')
    },
    goInvite () {
      this.$emit('goInviteModalGuide')
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.guide{
  width: 86.64vw;
  height: 113.13vw;
  background-size: 100% 100%;
  //border: 1px solid red;
  position: relative;
  animation: expandBox 0.3s ease-out forwards;
  @keyframes shrinkTitle {
    0% {
      transform: scale(2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  .title {
    font-size: 5.55vw;
    color: #FFFFFF;
    font-weight: 700;
    text-shadow: 0 0 0px #FFFFFF, 0 0 0px #FFFFFF, 0 0 2px #FFFFFF, 0 0 10px #FFFFFF;
    text-align: center;
    position: absolute;
    top: -15vw;
    letter-spacing: 0.1vw;
    animation: shrinkBox 0.5s ease-in forwards;
    width: 100%;
    text-align: center;
  }
  .close{
    height: 4.05vw;
    width: 4.05vw;
    position: absolute;
    top: -23vw;
    left: 77vw;
  }
  @keyframes expandBoxMinimum {
    from {
      opacity: 0;
      //width: 0;
    }
    to {
      opacity: 1;
      //width: 86.64vw;
    }
  }
  .minimum{
    color: #000000;
    font-weight: 700;
    font-size: 4.861vw;
    display: flex;
    align-items: center;
    position: absolute;
    left: 12vw;
    top: 7vw;
    //width: 0;
    overflow: hidden;
    animation: expandBoxMinimum 2s ease-in-out forwards;
    .value{
      color: transparent;
      font-weight: 700;
      background-image: linear-gradient(to bottom, #FFB700 0%, #FF9C12 100%);
      -webkit-background-clip: text;
      margin-left: 1vw;
    }
  }
  .maximum{
    color: #000000;
    font-weight: 700;
    font-size: 4.861vw;
    display: flex;
    align-items: center;
    position: absolute;
    left: 34.5vw;
    top: 14vw;
    animation: expandBoxMinimum 2s ease-in-out forwards;
    .value{
      color: transparent;
      font-weight: 700;
      background-image: linear-gradient(to bottom, #FF924F 0%, #994F00 100%);
      -webkit-background-clip: text;
      margin-left: 1vw;
    }
  }
  .deepBox{
    height: 68vw;
    width: 67.94vw;
    //background-color: #6F6F6F;
    border-radius: 2.5vw;
    position: absolute;
    top: 23vw;
    left: 9.5vw;
    background-size: 100% 100%;
  }
  .goInviteBtn{
    background-color: #0084FF;
    color: #fff;
    width: 77.22vw;
    height: 10.833vw;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 96vw;
    left: 4.5vw;
    border-radius: 2.22vw;
  }
  .deepBoxs{
    height: 54.166vw;
    width: 1.66vw;
    position: absolute;
    top: 6vw;
    left: 6vw;
    .deepBg{
      height: 100%;
      width: 100%;
      background-color: #000;
      border-radius: 0.7vw;
    }
    .nodeBox{
      position: absolute;
      top: -1vw;
      //left: -0.6vw;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .nodeIcon1{
        position: absolute;
        height: 3.05vw;
        width: 3.05vw;
        top: 0%;
        left: -0.75vw;
        .border1{
          height: 3.055vw;
          width: 3.055vw;
          background-color: rgba(255,255,255,0.5);
          border-radius: 10vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          box-shadow: 0 0 10px 0.05vw rgba(255, 255, 255, 0.5);
          .border2{
            height: 2.163vw;
            width: 2.163vw;
            background-color: rgba(255,255,255,0.8);
            border-radius: 10vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .border3{
              height: 1.33vw;
              width: 1.33vw;
              border-radius: 10vw;
              background-color: #fff;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .nodeIcon2{
        position: absolute;
        height: 3.05vw;
        width: 3.05vw;
        top: 50%;
        .border1{
          height: 3.055vw;
          width: 3.055vw;
          //background-color: #F3FF6E;
          background-color: rgba(243,255,110,0.5);
          border-radius: 10vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .border2{
            height: 2.163vw;
            width: 2.163vw;
            background-color: rgba(243,255,110,0.8);
            border-radius: 10vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .border3{
              height: 1.33vw;
              width: 1.33vw;
              border-radius: 10vw;
              background-color: #FDFFEA;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .nodeIcon3{
        position: absolute;
        height: 3.055vw;
        width: 3.055vw;
        top: 100%;
        .border1{
          height: 3.055vw;
          width: 3.055vw;
          background-color: rgba(30,75,24);
          border-radius: 10vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .border2{
            height: 2.163vw;
            width: 2.163vw;
            background-color: rgba(30,255,0,0.8);
            border-radius: 10vw;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .border3{
              height: 1.33vw;
              width: 1.33vw;
              border-radius: 10vw;
              background-color: rgba(30,255,0,1);
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }

      }
    }
    .deep{
      border-radius: 0.7vw;
      //height: 50%;
      width: 100%;
      background-image: linear-gradient(to bottom, #FFEBCE 0%, #2AFE00 100%);
      transition: height 1.5s ease-out;
    }
  }
  .nodeTextBox{
    height: 59.166vw;
    width: 1.66vw;
    position: absolute;
    top: 4.5vw;
    left: 10vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .textItem{
      font-size: 3.61vw;
      color: #F5F5F5;
      width: 55vw;
      height: 5vw;
      display: flex;
      align-items: center;
      //border: 1px solid red;
      justify-content: space-between;
      letter-spacing: 0.1vw;
      text-shadow: 0 0 0px #FFFFFF, 0 0 0px #FFFFFF, 0 0 1px #FFFFFF, 0 0 0px #FFFFFF;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      @keyframes shrinkBox {
        0% {
          transform: scale(5);
          opacity: 1; /* 完全不透明 */
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      .finishIcon{
        height: 8vw;
        width: 8vw;
        animation: shrinkBox 0.6s ease-in forwards;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modal-guide.vue